import StandaloneSvgChartRange from '@/pages/Dashboards/Charts/SVGChart/StandaloneSvgChartRange'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import useEquipment from '@/pages/Equipment/hooks/useEquipment'
import { IParameter } from '@/pages/Parameters/parameters.types'
import { memo, useMemo } from 'react'
import liftCardConfig from '../liftCard.config'
import liftCardSvgSettings from '../liftCard.svgSettings'
import LiftCardWidget from '../LiftCardWidget'
import liftWidgetSrc from '../liftWidget.src'
import useParametersValuesRange from '@/services/data/hooks/useParametersValuesRange'
import parametersSelectors from '@/pages/Parameters/parameters.selectors'
import { useRecoilValue } from 'recoil'

interface IProps {
  equipmentId: IEquipment['id']

  tsFrom: number
  tsTo: number
  tsCurrent: number
}

const LiftCardRange = (props: IProps) => {
  const equipment = useEquipment(props.equipmentId)
  const sourceIdToIdMap = useRecoilValue(parametersSelectors.getSourceIdToIdMap)

  const parametersConfig = useMemo(
    () => liftCardConfig.mapSourceIdsToParameterIds(equipment.protocolId, sourceIdToIdMap),
    [equipment.protocolId, sourceIdToIdMap]
  )

  const widgetConfig = useMemo(
    () => liftCardConfig.generateWidgetConfig(liftCardSvgSettings(equipment, sourceIdToIdMap)),
    [equipment, sourceIdToIdMap]
  )

  const config = useMemo(
    () => ({
      tsFrom: props.tsFrom,
      tsTo: props.tsTo,
      equipmentId: props.equipmentId,
      parameters: liftCardConfig
        .getSourceIds(equipment.protocolId)
        .map((sourceId) => sourceIdToIdMap[sourceId])
        .filter(Boolean) as Array<IParameter['id']>,
    }),
    [equipment.protocolId, sourceIdToIdMap, props.tsFrom, props.tsTo, props.equipmentId]
  )

  const ctrl = useParametersValuesRange({
    ...config,
    tsCurrent: props.tsCurrent,
  })

  const renderContent = () => {
    return (
      <StandaloneSvgChartRange
        {...props}
        svgFileSrcString={liftWidgetSrc}
        widget={widgetConfig}
        textParameterPreprocessFn={liftCardConfig.parameterPreprocess}
      />
    )
  }

  return (
    <LiftCardWidget
      chart={renderContent()}
      loading={ctrl.loading}
      values={ctrl.values}
      equipment={equipment}
      live={false}
      labels={parametersConfig.labels}
      parameters={parametersConfig.parameters}
    />
  )
}

export default memo(LiftCardRange)
